import { LuShare2 } from '@react-icons/all-files/lu/LuShare2'
import React from 'react'

import Tooltip from 'components/ui/tooltip'

type Props = {
  size?: number | string
}

export default function ShareArrowIcon({ size }: Props) {
  return (
    <Tooltip content={'Share'}>
      <LuShare2 size={size || 20} />
    </Tooltip>
  )
}
